import { useRuntimeConfig } from '#imports'

import type { Market } from '@backmarket/http-api'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'
import type { RouteRecordRaw } from 'vue-router'

import { PRODUCT } from './route-names'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const defaultLocale = toBcp47Locale(market.defaultLocale)

  const { FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_PRODUCT } =
    useRuntimeConfig().public

  const disableClientSideNavigation = !(
    FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_PRODUCT as string
  )?.includes(market.countryCode)

  return [
    {
      component: () => import('./pages/Product.vue'),
      name: PRODUCT.HOME,
      path: `/:locale(${defaultLocale})/p/:slugV2/:uuid`,
      meta: {
        disableClientSideNavigation: () => disableClientSideNavigation,
      },
    },
  ]
}
